<oel-header-transactionnel
  class="oel-header"
  *ngIf="!isApp && isNavBarDisplayed && !isDsdContext"
  [langue]="langue"
  [urlRetour]="urlRetour"
  [comportementBoutonRetour]="comportementBoutonRetour"
  (boutonAnnulerCliquee)="headerLinkClick($event)"
  est-authentifie="true"
  taille-texte-normale="100%"
  taille-texte-moyenne="150%"
  taille-texte-large="200%"
  base-rem="base-16"
  type-container="n3-fluid-limited"
  [libelleBoutonRetour]="libelleBoutonRetour | translate"
></oel-header-transactionnel>
<oel-header-transactionnel
  class="oel-header"
  *ngIf="!isApp && isNavBarDisplayed && isDsdContext"
  [langue]="langue"
  [urlRetour]="urlRetour"
  [comportementBoutonRetour]="comportementBoutonRetour"
  (boutonAnnulerCliquee)="headerLinkClick($event)"
  est-authentifie="true"
  taille-texte-normale="100%"
  taille-texte-moyenne="150%"
  taille-texte-large="200%"
  base-rem="base-16"
  type-container="dsd-standard"
  [libelleBoutonRetour]="libelleBoutonRetour | translate"
></oel-header-transactionnel>
<div
  [ngClass]="{
    'app-container': !isDsdContext,
    'app-container-dsd': isDsdContext
  }"
>
  <div class="router-outlet-container app-habitation">
    <router-outlet></router-outlet>
  </div>
</div>
<oel-footer-transactionnel type-container="dsd-standard" base-rem="base-16" [langue]="langue">
</oel-footer-transactionnel>

<app-popup-container></app-popup-container>

<app-loading></app-loading>
